// The salon charges deposits iff reservationMode === "deposit" (and the back only accepts it with validated
// payments), so the mode is derived from the deposits loaded in services and professional overrides.
import {
  beautyListProfessionalsApi,
  beautyListServicesApi,
  beautyUpdateSalonApi,
} from "../../api/organizerBeautyApi";

export const MSG_ERROR_MODO = "Guardamos los cambios, pero no pudimos actualizar el cobro de señas del salón. Probá de nuevo más tarde.";

const positivo = (v) => Number(v) > 0;
const activos = (lista) => (Array.isArray(lista) ? lista : []).filter((x) => x?.active !== false);

export const hayServicioConSena = (servicios) => activos(servicios).some((s) => positivo(s.deposit));

/** "deposit" when payments are validated and some active service (or professional override) has a deposit. */
export const modoReservaDerivado = (servicios, profesionales, puedeCobrar) => {
  if (!puedeCobrar) return "free";
  const conOverride = activos(profesionales).some((p) => (p.serviceOverrides || []).some((o) => positivo(o.deposit)));
  return hayServicioConSena(servicios) || conOverride ? "deposit" : "free";
};

const lista = (res) => (Array.isArray(res?.data?.info) ? res.data.info : []);

/**
 * Recomputes the mode after a service/professional save and updates the salon only when it changed.
 * Only while payments are validated. Never throws: returns `{ patch }` with the new salon fields, `{ error: true }` on failure, `{}` when nothing to do.
 * `servicios` / `profesionales` can be passed when the caller just loaded them; otherwise they are fetched.
 */
export const sincronizarModoReserva = async (salon, { puedeCobrar, cargando, servicios, profesionales } = {}) => {
  // Without validated payments nothing is touched: a deposit salon would otherwise be downgraded for good.
  if (!salon?._id || cargando || !puedeCobrar) return {};
  try {
    let srv = servicios;
    let pros = profesionales;
    if (!srv) srv = lista(await beautyListServicesApi());
    if (!hayServicioConSena(srv) && !pros) pros = lista(await beautyListProfessionalsApi());
    const deseado = modoReservaDerivado(srv, pros, puedeCobrar);
    if (deseado === (salon.reservationMode || "free")) return {};
    const fd = new FormData();
    fd.append("id", salon._id);
    fd.append("reservationMode", deseado);
    const res = await beautyUpdateSalonApi(fd);
    return { patch: { reservationMode: res?.data?.info?.reservationMode || deseado } };
  } catch (_) {
    return { error: true };
  }
};
